import type { RouteObject } from 'react-router-dom'
import { Outlet } from 'react-router-dom'

const routes: RouteObject = {
  path: '/onboarding',
  lazy: async () => {
    const { OnboardingGuard, OnboardingLayout } = await import('../../../features/account-settings')
    return {
      Component: () => (
        <OnboardingGuard>
          <OnboardingLayout>
            <Outlet />
          </OnboardingLayout>
        </OnboardingGuard>
      )
    }
  },
  children: [
    {
      path: 'change-initial-password',
      index: true,
      lazy: async () => {
        const { OnboardingChangeInitialPasswordPage } =
          await import('../../../features/account-settings')
        return { Component: OnboardingChangeInitialPasswordPage }
      }
    },
    {
      path: 'enable-mfa',
      lazy: async () => {
        const { OnboardingEnableMFAPage } = await import('../../../features/account-settings')
        return { Component: OnboardingEnableMFAPage }
      }
    }
  ]
}

export default routes
